import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntitySettingApi } from 'api';

export const findEntitySetting = createAsyncThunk(
  'entitySetting/findEntitySetting',
  async (_, { rejectWithValue }) => {
    try {
      const response = await EntitySettingApi.find();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDisplaySetting = createAsyncThunk(
  'entitySetting/findDisplaySetting',
  async (_, { rejectWithValue }) => {
    try {
      const response = await EntitySettingApi.findDisplaySetting();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntitySetting = createAsyncThunk(
  'entitySetting/updateEntitySetting',
  async (param: any, { rejectWithValue }) => {
    const { key, body } = param;
    try {
      const response = await EntitySettingApi.update(key, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMultiEntitySetting = createAsyncThunk(
  'entitySetting/updateMultiEntitySetting',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntitySettingApi.updateMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  isLoading: boolean;
  isLoaded: boolean;

  entitySettingData: any;
  orderSettingData: any;
  policySettingData: any;
  productSettingData: any;

  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  updateFlag?: number;
  query: any;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  isLoading: false,
  isLoaded: false,

  entitySettingData: {},

  orderSettingData: {},
  policySettingData: {},
  productSettingData: {},

  tableList: [],
  list: [],
  reloadFlag: false,
  query: {},
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entitySettingSlice = createSlice({
  name: 'entitySetting',
  initialState,
  reducers: {
    reloadEntitySetting(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    triggerUpdateSetting(state) {
      state.updateFlag = new Date().getTime();
    },
    disableUpdateSetting(state) {
      state.updateFlag = undefined;
    },
    updateOrderSettingData(state, action) {
      state.orderSettingData = action.payload;
    },
    updatePolicySettingData(state, action) {
      state.policySettingData = action.payload;
    },
    updateProductSettingData(state, action) {
      state.productSettingData = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(findEntitySetting.fulfilled, (state, action) => {
      state.isLoaded = true;
      state.entitySettingData = action.payload.data;
    });
    builder.addCase(updateMultiEntitySetting.fulfilled, (state, action) => {
      state.isLoaded = false;
    });
  },
});

const { actions, reducer: entitySettingReducer } = entitySettingSlice;

export const {
  reloadEntitySetting,
  updateOrderSettingData,
  updatePolicySettingData,
  updateProductSettingData,
  triggerUpdateSetting,
  disableUpdateSetting,
} = actions;

export default entitySettingReducer;
